import { useEffect, useState } from "react";
import { X } from "lucide-react";
import AppStoreBadges from "@/components/landing/AppStoreBadges";

const STORAGE_KEY = "piefolio_blog_sticky_dismissed";

const StickyMobileAppBar = () => {
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (!dismissed) setHidden(false);
  }, []);

  const dismiss = () => {
    setHidden(true);
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* no-op */
    }
  };

  if (hidden) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-40 md:hidden border-t border-border bg-background/95 backdrop-blur-xl px-3 py-2.5 shadow-lg">
      <div className="flex items-center gap-2">
        <button
          onClick={dismiss}
          aria-label="Dismiss"
          className="p-1.5 text-muted-foreground hover:text-foreground"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="flex-1 text-xs text-foreground/80 leading-tight min-w-0">
          <span className="font-semibold text-foreground block truncate">
            Get PieFolio AI
          </span>
          <span className="block text-foreground/60 truncate">
            Free portfolio tracker
          </span>
        </div>
        <AppStoreBadges size="sm" variant="dark" location="blog-sticky" />
      </div>
    </div>
  );
};

export default StickyMobileAppBar;
